import React from 'react';

const Footer = () => (
  <footer style={{ padding: '1rem', backgroundColor: '#F8F9FA', textAlign: 'center' }}>
    <p>© 2024 Your Company. All Rights Reserved.</p>
  </footer>
);

export default Footer;